
function newOnLabelTap(event) {
    const dropdown = document
        .querySelector('.injecter-recharge-actions__mobile-options-wrapper');

    let dropDownOpen = dropdown.classList.contains('open');

    if (dropDownOpen) {
        dropdown.classList.remove('open');
    }
    if (!dropDownOpen && dropdown.contains(event.target)) {
        dropdown.classList.add('open');
    }
}

// ----------------------------------------------------------------------------------------------------------------
// CALIFORNIA SUBSCRIPTION TERMS CHECKBOX LOGIC
// Detects if user is in California and shows checkbox for subscription terms agreement
// ----------------------------------------------------------------------------------------------------------------

const CA_STORAGE_KEY = 'athena_user_state';

// Check if user is in California using IP geolocation
async function detectCaliforniaResident() {
    // Check if we already have the state cached
    const cachedState = localStorage.getItem(CA_STORAGE_KEY);
    if (cachedState) {
        return cachedState === 'CA';
    }
    
    try {
        // Use ipapi.co for state-level geolocation (free tier available)
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        // Check if the user is in California, USA
        if (data.country_code === 'US' && data.region_code) {
            localStorage.setItem(CA_STORAGE_KEY, data.region_code);
            return data.region_code === 'CA';
        }
        
        // Not in US, store that information
        localStorage.setItem(CA_STORAGE_KEY, 'NON_US');
        return false;
    } catch (error) {
        console.warn('Could not detect user location:', error);
        // On error, don't show the checkbox (fail gracefully)
        return false;
    }
}

// Setup California subscription terms checkbox
async function setupCaliforniaSubscriptionTerms() {
    const caTermsContainer = document.getElementById('ca-subscription-terms');
    const caCheckbox = document.getElementById('ca-subscription-agree');
    const addToCartButton = document.getElementById('AddToCart');
    
    if (!caTermsContainer || !caCheckbox) {
        return; // No subscription widget on this page
    }
    
    // Detect if user is in California
    const isCaliforniaResident = await detectCaliforniaResident();
    
    if (!isCaliforniaResident) {
        // Not a California resident, no need for the checkbox
        return;
    }
    
    // Track the current purchase option (subscription or onetime)
    let isSubscriptionSelected = document.querySelector('input[name="purchaseOption"]:checked')?.value === 'subscription';
    
    // Function to update the add to cart button state
    function updateAddToCartState() {
        if (!addToCartButton) return;
        
        if (isSubscriptionSelected && !caCheckbox.checked) {
            // Subscription selected but checkbox not checked - disable button
            addToCartButton.disabled = true;
            addToCartButton.classList.add('ca-terms-required');
        } else {
            // Either one-time purchase or checkbox is checked - enable button
            // (but respect other disabled states like sold out)
            const variantAvailable = !addToCartButton.hasAttribute('data-variant-unavailable');
            if (variantAvailable) {
                addToCartButton.disabled = false;
            }
            addToCartButton.classList.remove('ca-terms-required');
        }
    }
    
    // Function to show/hide the California terms checkbox
    function updateCaliforniaTermsVisibility() {
        if (isSubscriptionSelected) {
            caTermsContainer.style.display = 'block';
            updateAddToCartState();
        } else {
            caTermsContainer.style.display = 'none';
            // Remove error state when hiding
            caTermsContainer.classList.remove('ca-subscription-terms--error');
            updateAddToCartState();
        }
    }
    
    // Listen for purchase option changes (subscription vs one-time)
    const purchaseOptionInputs = document.querySelectorAll('input[name="purchaseOption"]');
    purchaseOptionInputs.forEach(function(input) {
        input.addEventListener('change', function() {
            isSubscriptionSelected = input.value === 'subscription';
            updateCaliforniaTermsVisibility();
        });
    });
    
    // Listen for checkbox changes
    caCheckbox.addEventListener('change', function() {
        // Remove error state when checkbox is checked
        if (caCheckbox.checked) {
            caTermsContainer.classList.remove('ca-subscription-terms--error');
        }
        updateAddToCartState();
    });
    
    // Intercept form submission to validate checkbox
    const productForm = document.querySelector('.product-form form, form[action*="/cart/add"]');
    if (productForm) {
        productForm.addEventListener('submit', function(e) {
            if (isSubscriptionSelected && !caCheckbox.checked) {
                e.preventDefault();
                e.stopPropagation();
                
                // Show error state
                caTermsContainer.classList.add('ca-subscription-terms--error');
                
                // Scroll to the checkbox
                caTermsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                
                return false;
            }
        });
    }
    
    // Update frequency text when selling plan changes
    const freqOptions = document.querySelectorAll('.injecter-recharge__mobile-option');
    freqOptions.forEach(function(option) {
        option.addEventListener('click', function() {
            const frequencyText = caTermsContainer.querySelector('.ca-subscription-terms__frequency');
            if (frequencyText) {
                frequencyText.textContent = option.textContent.trim();
            }
        });
    });
    
    // Listen for variant changes to update price
    document.addEventListener('variant:changed', function(e) {
        const variant = e.detail.variant;
        if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const priceElement = caTermsContainer.querySelector('.ca-subscription-terms__price');
            if (priceElement) {
                const price = (variant.selling_plan_allocations[0].price / 100).toFixed(2);
                priceElement.textContent = '$' + price;
            }
        }
    });
    
    // Initial visibility check
    updateCaliforniaTermsVisibility();
}

function setupEventListeners(){

    const selectedLabel = document
        .getElementsByClassName('injecter-recharge-actions__mobile-selected')[0];

    const subPriceContainer = document.querySelector('.rc-radio.subscription-radio .price-label-number');
    const oneTimePriceContainer = document.querySelector('.rc-radio.onetime-radio .price-label-number');

    const caret = document.querySelector('.injecter-recharge-actions__caret');

    // For opening dropdown
    selectedLabel.addEventListener(('click'), function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        newOnLabelTap(e);

    }, true)

    // For closing dropdown if somewhere else on the page is clicked
    document.addEventListener('click', function (e) {
        const dropdown = document
            .querySelector('.injecter-recharge-actions__mobile-options-wrapper');

        if (selectedLabel.contains(e.target) || !dropdown.classList.contains('open')) { return; }

        dropdown.classList.remove('open');
    }, true);

    const freqOptions = document.getElementsByClassName('injecter-recharge-actions__mobile-options')[0]
        .querySelectorAll('.injecter-recharge__mobile-option');

    const selling_plan_input = document.querySelector('input[name="selling_plan"]')

    document.addEventListener('variant:changed', function(e) {
        let variant = e.detail.variant;
        let displayedPlans = variant.selling_plan_allocations.map((plan) => plan.selling_plan_id);
        freqOptions.forEach((option) => {
            let optionSellingPlanId = parseInt(option.getAttribute('data-option'));
            if (optionSellingPlanId && !displayedPlans.includes(optionSellingPlanId)){
                option.classList.add('hidden');
            } else {
                option.classList.remove('hidden');
            }
        })

        if(displayedPlans.length < 2){
            caret.classList.add('hidden');
            selectedLabel.classList.remove('underline');
        } else {
            caret.classList.remove('hidden');
            selectedLabel.classList.add('underline');
        }

        let planToSelect = Array.from(freqOptions).find((option) => {
            let planToCompare = ((displayedPlans.find((plan) => parseInt(selling_plan_input.value) == plan))) ?? displayedPlans[0]
            return parseInt(option.getAttribute('data-option')) === planToCompare
        })

        let allocationToSelect = variant.selling_plan_allocations.find((alloc) => {
            return alloc.selling_plan_id === parseInt(planToSelect.getAttribute('data-option'));
        })

        // handled in product-meta in theme.js with other price updates
        // oneTimePriceContainer.innerHTML = `${(variant.price/100).toFixed(2)}`
        // subPriceContainer.innerHTML = `${(allocationToSelect.price/100).toFixed(2)}`

        planToSelect.click();
    })

    // For selecting a new selling plan

    Array.from(freqOptions).forEach(element => {
        element.addEventListener('click',(e) => {
            const freqOption = element.dataset.option;
            selling_plan_input.value = freqOption
            selectedLabel.querySelector('p').innerHTML = element.innerHTML;
        })
    });

    // For one time/subscription radio selectors
    let input = document.querySelectorAll('input[name="purchaseOption"]');
    input.forEach(function (item) {
        item.addEventListener('change', function () {
            if (item.value === 'onetime') {
                selling_plan_input.value = "";
                document.querySelector('.onetime-radio').classList.add('rc-radio--active');
                document.querySelector('.subscription-radio').classList.remove('rc-radio--active');
            } else if (item.value === 'subscription') {
                selling_plan_input.value = Array.from(freqOptions).find((option) => {
                    return option.innerHTML.toLowerCase() === selectedLabel.querySelector('p').innerHTML.toLowerCase()
                }).dataset.option;
                document.querySelector('.onetime-radio').classList.remove('rc-radio--active');
                document.querySelector('.subscription-radio').classList.add('rc-radio--active');
            }
        });
    });

    // For query parameters
    const parameters = new URLSearchParams(window.location.search);
    const sellingPlan = parameters.get('selling_plan');
    const oneTimePurchase = parameters.get('otp');

    if (sellingPlan) {
        let selectPlanLabel = document.querySelector(`li[data-option='${sellingPlan}']`)
        selectPlanLabel.click();
    }
    if (oneTimePurchase) {
        const onetimeRadioLabel = document.querySelector('.onetime-radio').querySelector('.rc-radio__label');
        onetimeRadioLabel.click();
    }
    
    // Initialize California subscription terms checkbox
    setupCaliforniaSubscriptionTerms();
}

if(window.themeVariables.rechargePresent){
    setupEventListeners()
}
